/**
 * 旧 5 入口(/hr/onboarding など)のブックマーク救済。`/hr/requests/new?kind=` に飛ばす。
 * ナビからは外した(UX1-b2: 申請の入口は「新しい申請」1 つ)。
 */
import { Navigate } from "react-router-dom";

const to = (kind: string) => `/hr/requests/new?kind=${kind}`;

export function OnboardingRedirect() {
  return <Navigate replace to={to("onboard")} />;
}
export function OffboardingRedirect() {
  return <Navigate replace to={to("offboard")} />;
}
export function TransferRedirect() {
  return <Navigate replace to={to("transfer")} />;
}
export function LeavesRedirect() {
  return <Navigate replace to={to("leave")} />;
}
export function UpdatesRedirect() {
  return <Navigate replace to={to("update")} />;
}
